import React from "react";
import { TESTIMONIALS, BRAND_COPY } from "../mock";
import { Quote } from "lucide-react";

const Testimonials = () => {
  return (
    <section className="py-24 md:py-28 border-t border-off-white/10 bg-charcoal-2">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="mb-14 grid md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-3">// 05 — THE FEEDBACK LOOP</p>
            <h2 className="font-serif-display italic text-5xl md:text-7xl leading-[0.95] text-off-white">Field reports.</h2>
          </div>
          <div className="md:col-span-5 border-l-2 border-rose pl-5">
            <p className="font-serif-display italic text-xl md:text-2xl text-off-white/90 leading-snug">
              “{BRAND_COPY.favoriteSayings[0]}.”
            </p>
            <p className="font-mono text-[10px] tracking-[0.3em] text-rose mt-3">// FAVORITE SAYING</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {TESTIMONIALS.map((t, i) => (
            <figure key={i} className="border border-off-white/10 p-6 bg-charcoal hover:border-off-white transition-colors-only relative">
              <Quote size={20} className="text-rose mb-4" strokeWidth={1.5} />
              <blockquote className="text-off-white/85 leading-relaxed text-[15px] font-light">“{t.text}”</blockquote>
              <figcaption className="mt-6 pt-4 border-t border-off-white/10">
                <p className="text-sm text-off-white font-medium">{t.name}</p>
                <p className="font-mono text-[10px] tracking-[0.25em] text-off-white/50 uppercase">{t.location}</p>
              </figcaption>
              <span className="absolute top-3 right-4 font-mono text-[10px] tracking-[0.2em] text-off-white/25">0{i + 1}</span>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
